/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/all',[
    'global/all',
    './Cart/all',
    './Banners/BannersTracking',
    './Checkout/all',
    './Favorites/all',
    './Newsletter/Newsletter',
    './Product/all',
    './QuestionAndAnswer/QuestionAndAnswer',
    './QuickView/QuickView',
    './RelatedProducts/RelatedProducts',
    './Reviews/all',
    './Site/SiteHeader',
    './User/all',
    './PortalUser/PortalUsers',
    './PortalFooter/PortalFooter',
    './HTNow/ContactUsParts'
], function (Roc) {
    Roc.Logger.debug('Loaded all modules...');
    
    return {};
});

